import { render, staticRenderFns } from "./QuestionTableItem.vue?vue&type=template&id=2535c420&scoped=true&"
import script from "./QuestionTableItem.vue?vue&type=script&lang=ts&"
export * from "./QuestionTableItem.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionTableItem.vue?vue&type=style&index=0&id=2535c420&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2535c420",
  null
  
)

export default component.exports